import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';
import { Bell } from 'lucide-react';

export function ButtonsSection() {
  const showToast = () => {
    toast.success('Hello from Sonner!', {
      description: 'This is a beautiful toast notification.',
    });
  };

  return (
    <Card className='mb-8'>
      <CardHeader>
        <CardTitle>Buttons</CardTitle>
        <CardDescription>Various button styles and states</CardDescription>
      </CardHeader>
      <CardContent className='space-y-4'>
        <div className='flex flex-wrap gap-4'>
          <Button>Default</Button>
          <Button variant='secondary'>Secondary</Button>
          <Button variant='destructive'>Destructive</Button>
          <Button variant='outline'>Outline</Button>
          <Button variant='ghost'>Ghost</Button>
          <Button variant='link'>Link</Button>
          <Button size='sm'>Small</Button>
          <Button size='lg'>Large</Button>
          <Button disabled>Disabled</Button>
          <Button onClick={showToast}>
            <Bell className='mr-2 h-4 w-4' />
            Show Toast
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
